import CartoonBox from '../../../CartoonBox/CartoonBox';
import { StyledQuestionInteractionBox } from './QuestionInteractionBox.styled';

export default function QuestionInteractionBox({
  box,
  src,
  className = '',
  centerPoint = [50, 50],
}) {
  return (
    <StyledQuestionInteractionBox
      className={className}
      centerPoint={centerPoint}
    >
      <CartoonBox box={box} src={src} />
    </StyledQuestionInteractionBox>
  );
}
